export default "__VITE_ASSET__Dy5_BY$O__"